import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-trash",
  "use": "svg_i-trash-usage",
  "viewBox": "0 0 11 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 13\" id=\"svg_i-trash\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 3v10H1V3H0V2h3V1h1v1h3V1h1v1h3v1h-1zM9 3H2v9h7V3zm-5 7H3V5h1v5zm2 0H5V5h1v5zm2 0H7V5h1v5zM4 0h3v1H4V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol